module.exports = __webpack_public_path__ + "img/true360-white.c3eb8d98.png";